export function assertBeatCountValid(beatCount: number): void {
  if (beatCount < 1) {
    throw new Error(`Beat count has to be > 1 but was ${beatCount}`);
  }
}
